<template>
  <div>
    <div class="position-relative" v-if="adminSummaryPermissions">
      <app-overlay-loader v-if="preloader"/>
      <div v-if="subscription.expired && showBanner" class="banner">
        <div class="banner-content">
          <span><strong>Your subscription has expired.</strong> Please renew to continue using the service.</span>
          <button class="close-btn" @click="showBanner = false">&times;</button>
        </div>
      </div>
      <div class="row mb-primary" :class="{'loading-opacity': preloader}">
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_employees')">
          <app-widget
              type="app-widget-with-icon"
              :label="$t('total_employees')"
              :number="numberFormatter(cardSummaries.total_employee)"
              icon="user"
              href="employee/lists"
          />
        </div>
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_departments')">
          <app-widget
              type="app-widget-with-icon"
              id="employee_widget"
              :label="$t('total_departments')"
              :number="numberFormatter(cardSummaries.total_department)"
              icon="home"
              href="administration/departments"
          />
        </div>
        <div class="col-sm-6 col-lg-3 mb-4 mb-sm-0" v-if="$can('view_all_leaves')">
          <app-widget
              type="app-widget-with-icon"
              id="leave_widget"
              :label="$t('total_leave_requests')"
              href="leave/requests"
              :number="numberFormatter(cardSummaries.total_leave_request)"
              icon="edit"
          />
        </div>
        <div class="col-sm-6 col-lg-3 mb-lg-0 mb-4" v-if="$can('view_all_leaves')">
          <app-widget
              type="app-widget-with-icon"
              :label="$t('on_leave_today')"
              href="leave/status"
              :number="numberFormatter(cardSummaries.on_leave_today)"
              icon="user-x"
          />
        </div>
      </div>
      <div class="row mb-primary" :class="{'loading-opacity': preloader}">
        <div class="col-sm-6 col-lg-3 mb-4" v-if="$can('view_tenants')">
          <app-widget
              type="app-widget-with-icon"
              :label="$t('total_companies')"
              :number="numberFormatter(cardSummaries.total_companies)"
              icon="briefcase"
              href="app/tenants/lists"
          />
        </div>
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_transactions')">
          <app-widget
              type="app-widget-with-icon"
              :label="$t('total_transactions')"
              :number="formatCurrency(cardSummaries.total_transactions)"
              icon="dollar-sign"
              href="transactions"
          />
        </div>
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_locations')">
          <app-widget
              type="app-widget-with-icon"
              :label="$t('total_locations')"
              :number="numberFormatter(cardSummaries.total_locations)"
              icon="map"
              href="location/lists"
          />
        </div>
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_transactions')">
          <app-widget
              type="app-widget-with-icon"
              :label="$t('total_tickin_points')"
              :number="numberFormatter(Number(cardSummaries.total_tickin_points))"
              icon="award"
              href="attendances/tickin/report"
          />
        </div>
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_transactions')">
          <app-widget
              type="app-widget-with-icon"
              :label="$t('total_working_hours')"
              :number="numberFormatter(Number(cardSummaries.total_working_hours))"
              icon="clock"
              href="attendances/details"
          />
        </div>
      </div>
    </div>

    <!--        <div class="row">-->
    <!--            <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9 mb-4 mb-md-0" v-if="employeeStatisticsPermissions">-->
    <!--                <app-employee-statistics/>-->
    <!--            </div>-->
    <!--            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3" v-if="attendancePermissions">-->
    <!--                <on-working-today/>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4 mb-md-0" v-if="employeeStatisticsPermissions">
        <on-working-today/>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" v-if="attendancePermissions">
        <app-employee-statistics/>
      </div>
    </div>
  </div>
</template>

<script>
import {numberFormatter, formatCurrency} from "../../../../../common/Helper/Support/SettingsHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {APP_DASHBOARD, CHECK_DEFAULT_WORKING_SHIFT} from "../../../../Config/ApiUrl";
import OnWorkingToday from "./OnWorkingToday";
import { ref } from 'vue';

export default {
  name: "AdminDashboard",
  components: {OnWorkingToday},
  data() {
    return {
      numberFormatter,
      formatCurrency,
      preloader: false,
      cardSummaries: {},
      subscription: null,
      showBanner: ref(true),
    }
  },
  created() {
    this.getSummeryData();
  },
  methods: {
    getSummeryData() {
      this.preloader = true;
      axiosGet(`${APP_DASHBOARD}/summery`).then(({data}) => {
        this.cardSummaries = data;
        this.subscription = data.subscription;
        this.preloader = false;
      })
    },
  },
  computed: {
    adminSummaryPermissions() {
      return this.$can('view_employees') ||
          this.$can('view_departments') || this.$can('view_all_leaves')
    },
    employeeStatisticsPermissions() {
      return this.$can('view_employment_statuses') ||
          this.$can('view_designations') || this.$can('view_departments')
    },
    attendancePermissions() {
      return this.$can('view_all_attendance')
    }
  }
}
</script>

<style scoped>

.banner {
  width: 100%;
  background-color: #ef4444; /* bg-red-500 */
  color: white;
  padding: 12px 16px;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06);
  position: relative;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}
.db-row-sep {
  margin-top: 2rem !important;
}
</style>